import React, { forwardRef } from "react";
import { BSAnchor } from "../../types";

export const DropdownItem = forwardRef<HTMLAnchorElement, BSAnchor>(
  ({ children, component: Component = "a", ...props }, ref) => (
    <Component {...props} className="dropdown-item" ref={ref}>
      {children}
    </Component>
  )
);